module.exports = __webpack_public_path__ + "img/357.c5bd1948.png";